// extracted by mini-css-extract-plugin
module.exports = {"container":"Query_container__J7xAm","iconWrapper":"Query_iconWrapper__PytGs","searchField":"Query_searchField__VjJ8O","clearButton":"Query_clearButton__GwYYg"};